import React, { FC, useEffect } from 'react';

import { ComponentQuery } from 'models';

import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { SearchService } from 'components/component-overview/services/SearchService';
import { AutoSave } from 'components/forms/AutoSave';
import { Form } from 'components/forms/Form';

const ComponentSearchForm: FC<{
    defaultValues?: Partial<ComponentQuery>;
    children: React.ReactNode;
}> = ({ defaultValues = {}, children }) => {
    const filters = useComponentSearchFilters();

    useEffect(() => {
        SearchService.mergeFilters(defaultValues);
    }, [JSON.stringify(defaultValues)]);

    return (
        <Form<ComponentQuery>
            defaultValues={filters}
            onSubmit={(values) => {
                SearchService.mergeFilters(values);
            }}
        >
            <AutoSave />
            {children}
        </Form>
    );
};

export { ComponentSearchForm };
